<template>
    <div class="language-switcher dropdown">
        <button type="button" class="btn dropdown-toggle" v-on:click="opened = !opened" :class="cButtonStyle">
            <img :src="'/static/flags/4x3/'+ currentLang + '.svg'" class="flag-icon">
        </button>
        <div class="dropdown-menu" x-placement="bottom-start" :class="{'show': opened}">
            <div class="dropdown-item"
                 v-for="(item, i) in supportedLangs"
                 v-on:click="setLanguage(item.key)"
                 v-if="item.key !== currentLang"
            >
                <img :src="'/static/flags/4x3/'+ item.key + '.svg'" class="flag-icon">
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'locale-switcher',
        props: {
            buttonStyle: {
                type: String,
                default: 'btn-secondary',
                required: false,
            }
        },
        created() {
            this.currentLang = this.$i18n.locale;
        },
        computed: {
            cButtonStyle() {
                return this.buttonStyle + ' ' + (this.opened === true ? 'show' : '');
            }
        },
        methods: {
            setLanguage(lang) {
                this.opened = false;
                this.$store.state.translate.loading = true;
                this.$emit('changed', lang);

                this.i18n.changeLanguage(lang).then(res => {
                    this.currentLang = res;
                    this.$store.state.translate.loading = false;
                })
            }
        },
        data() {
            return {
                opened: false,
                currentLang: null
            }
        }
    }
</script>
<style lang="scss">
    .language-switcher {
        .dropdown-menu {
            min-width: 62px;
            padding: 0;

            .dropdown-item {
                padding: 0.45rem 0.25rem;
                text-align: center;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/core/Translator/locale-switcher.vue